/* eslint-disable */

import FileSaver from 'file-saver'


export const exportToFile = async (array, name = 'file.json') => {
    const json = JSON.stringify(array)
    const blob = new Blob([json], {type: "text/plain;charset=utf-8"});
    FileSaver.saveAs(blob, name)
}

export const importFromFile = async (array, file) => {
}

const s2ab = s => {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF; // eslint-disable-line
    return buf;
}
